import { buildPrettyUrlFromAccount } from 'core/prettyUrlsExpose';

export const exposePath = (expose: any) => buildPrettyUrlFromAccount(expose);
